import type { Station } from "./types";

/** Phase-1 pilot sites (workers/CONTRACTS.md "Phase-1 config"). */
export const STATIONS: Station[] = [
  // Rollout is staged per-station via D1; a station without a manifest 404s →
  // "not yet active". Florida overlap mesh (KAMX/KBYX/KMLB/KTBW/KJAX) is the
  // fusion/QC research cluster — footprints deliberately overlap heavily.
  { id: "KAMX", lat: 25.6111, lon: -80.4128 },
  { id: "KBYX", lat: 24.59694, lon: -81.70333 },
  { id: "KMLB", lat: 28.11306, lon: -80.65444 },
  { id: "KTBW", lat: 27.7056, lon: -82.4019 },
  { id: "KJAX", lat: 30.48444, lon: -81.70194 },
  { id: "KHGX", lat: 29.4719, lon: -95.0788 },
  { id: "KLIX", lat: 30.3367, lon: -89.8256 },
  { id: "KMOB", lat: 30.6794, lon: -88.2397 },
];

export const DEFAULT_STATION = STATIONS[0].id;

export function stationById(id: string): Station {
  const s = STATIONS.find((x) => x.id === id);
  if (!s) throw new Error(`unknown station: ${id}`);
  return s;
}
